<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-change="onFormChange" >

        <div 
          slot="jt-form-slot-terminationTnc">
          <div
            id="terminationTnc"
            class="summernote" />  
        </div>

        <div
          slot="jt-form-slot-baySection">
          <AppTable 
            ref="pageBay" 
            v-bind:tableParameter="BAY_PARAM" />
        </div>

      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <button v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>
      <TemplateButton v-show="pageShowSave && hasAddOrEditPermission()" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Save
      </TemplateButton>
      <!--
      <button v-show="hasDeletePermission() && !pageIsAdd" v-on:click="onDeleteButtonClick" type="button" class="btn btn-danger">
        Delete
      </button>
      -->

      <TemplateModal
        v-bind:modalId="deleteModalId">
        <h4 slot="modal-title" class="modal-title" >
          {{ deleteModalTitle || 'Confirm Delete' }}
        </h4>
        <div slot="modal-body">
          {{ deleteModalBody || 'Are you sure you want to delete the selected item?' }}
        </div>
        <div slot="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Close
          </button>
          <button @click="onDeleteConfirmClick" type="button" class="btn btn-danger">
            Confirm
          </button>
        </div>
      </TemplateModal>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateModal from "@/components/Template/TemplateModal";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import AppTable from "@/components/App/AppTable";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const BAY_PARAM = [
  {
    key: 'type',
    text: 'Bay Type',
  },
  {
    key: 'allocation',
    text: 'Allocation (A)',
  },
  {
    key: 'oversell',
    text: 'Oversell (B)',
  },
  {
    key: 'used',
    text: 'Used (C)',
  },
  {
    key: 'entitlement',
    text: 'Entitlement (D)',
  },
  {
    key: 'entitlementUsed',
    text: 'Entitlement Used (E)',
  },
  {
    key: 'remain',
    text: '(A+B-C-D) Remain',
  },
];

const PARAM = [
  {
    form_section: 'Product Management',
  },
  {
    key: 'carparkID',
    text: 'Car Park',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
    form_edit_validation: [],
  },
  {
    key: 'zoneID',
    text: 'Zone',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'name',
    text: 'Product Name *',
  },
  // {
  //   key: 'image',
  //   text: 'Image',
  //   form_dropzone: true,
  //   form_input_validation: [],
  // },
  {
    key: 'remark',
    text: 'Description',
    form_textarea: true,
    form_input_validation: [],
  },
  {
    form_section: 'Bay Setting',
  },
  {
    key: 'isTenant',
    text: 'Tenant Type *',
    form_default: 1,
    form_radio: [
      { 1 : 'Tenant' },
      { 0 : 'Non-Tenant' },
    ],
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'bayType',
    text: 'Bay Type *',
    form_default: 2,
    form_radio: [
      { 2 : 'Reserved' },
      { 3 : 'Tandem-Reserved' },
      { 1 : 'Non-Reserved' },
      { 4 : 'Motorcycle' },
    ],
    form_edit_input_attr: {
      disabled: true,
    },
    form_container_attr: {
      'class': 'col-lg-6',
    },
  },
  {
    key: 'baySlots',
    text: 'Bay Slots (Tandem-Reserved) *',
    form_default: 1,
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'type': 'Number',
    },
    form_input_validation: validation.validatePositive,
    form_muted: '* Set the number of parker and number of passcard per product subscription.',
  },
  {
    key: 'totalBays',
    text: 'Allocate Bay Count',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_attr: {
      'type': 'Number',
    },
    form_input_validation: [validation.validateRequire, validation.validatePositive],
    form_muted: 'Fill in this field to set a limited bay count to this product. Leave it blank for auto allocation from Pool.',
  },
  {
    form_section: 'Product Setting',
  },
  {
    key: '_startDate',
    text: 'Product Start Date *',
    form_datepicker: true,
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_muted: 'Product applicable for application on this date.',
  },
  {
    key: '_stopDate',
    text: 'Product Stop Date',
    form_datepicker: true,
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
    form_muted: 'Product not applicable for application on this date.',
  },
  {
    key: 'minParkingDay',
    text: 'Minimum Parking Duration',
    form_input_attr: {
      'type': 'Number',
    },
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
    form_muted: 'Fill in this field to set minimum parking days. Leave it blank for minimum continuous period of ONE (1) calendar month.',
  },
  {
    key: 'durationTerminateDayNotice',
    text: 'Termination Notice Period',
    form_input_attr: {
      'type': 'Number',
    },
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
    form_muted: 'Fill in this field to set a termination notice days. Leave it blank for one calendar month of termination notice.',
  },
  {
    key: 'isEnable',
    text: 'Is Enabled Product',
    form_checkbox: true,
  },
  {
    key: 'isPublic',
    text: 'Is Public Visible Product',
    form_checkbox: true,
  },
  {
    key: 'isPriority',
    text: 'Is Priority Passcard Issuance',
    form_checkbox: true,
  },
  {
    key: 'entitleOnly',
    text: 'Is Entitlement Product',
    form_checkbox: true,
  },
  {
    key: 'terminationLastDay',
    text: 'Is Force Termination Effective Date on Last Day of Month',
    form_checkbox: true,
  },
  {
    form_section: 'Termination Application T&C',
  },
  {
    key: 'terminationTnc',
    form_div: true,
    form_muted: 'Fill in this field to have specific termination T&C for this product. Leave it blank to use general termination T&C.',
  },
  {
    key: 'baySection',
    form_html: () => '',
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PageProductForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    TemplateModal,
    AppForm,
    AppTable,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Car Park', url: '/carpark' },
        { name: 'Product' },
      ],

      API_PATH: "/api2/season/",
      PARAM,
      PARAM_MAP,
      BAY_PARAM,

      deleteModalId: null,
      deleteModalTitle: null,
      deleteModalBody: null,
      
      pageIsAdd: true,
      pageTitle: null,
      pageShowData: false,
      pageShowSave: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.deleteModalId = "jt-popup-modal-" + this._uid + '-delete';
    
    this.$nextTick(() => {
      helper.setSidebar('/product');
    });

    $('#terminationTnc').summernote({
      minHeight: '300px'
    });
    
    this.loadCarpark();
  },
  methods: {
    hideFormFromKey(key) {
      this.pageShowSave = false;

      if(key === null) {
        this.pageShowSave = true;
      }
      
      let hide = false;
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        parameter.form_hide = hide;
      });
    },

    loadCarpark() {
      this.hideFormFromKey('carparkID');
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], response.data);

          if(response.data.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('No car park data available');
            return;
          }

          this.loadZonex();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadZonex() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageZone = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.loadProduct();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    loadProduct() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');

      this.$http
        .get(
          helper.SERVER_URL + '/api2/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageProduct = response.data;
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
        });
    },
    async loadData() {
      let productID = this.$route.query.productID;
      if(productID) {
        this.pageIsAdd = false;

        this.$refs['pageFeedback'].setFeedbackLoading('Loading product terms and conditions...');
        if(
          !await this.$http
            .get(
              helper.SERVER_URL + '/api2/season/' + productID + '/terms',
              helper.createAxiosConfig()
            )
            .then(response => {
              let resultMeta = helper.processAxiosResponse(this, response);
              $('#terminationTnc').summernote('code', response.data && response.data[0] ? response.data[0].policy : '');
              return true;
            })
            .catch(error => {
              this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
            })
        ) {
          return;
        }
        
        this.$refs['pageFeedback'].setFeedbackLoading('Loading product data...');
        await this.$http
          .get(
            helper.SERVER_URL + '/api2/season/' + productID,
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            let tempData = response.data[0];
            if(tempData) {
              this.pageTitle = 'Edit ' + tempData.name;
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.pageShowData = true;
              
              tempData['_zone'] = this.pageZone.find(k => k.id === tempData.zoneID);
              tempData['_carpark'] = helper.inputSelectFindOption(this.PARAM_MAP['carparkID'], tempData['_zone'].carparkID);
              tempData['carparkID'] = tempData['_carpark'] ? tempData['_carpark'].id : '';

              tempData['_startDate'] = helper.formatDate(tempData['startDate']);
              tempData['_stopDate'] = helper.formatDate(tempData['stopDate']);

              this.$refs['pageForm'].setForm(false, tempData);
            } else {
              this.$refs['pageFeedback'].setFeedbackError('Problem loading product data.');
            }
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'product data'));
          })
      } else {
        this.pageIsAdd = true;
        this.pageTitle = 'Create New Product';

        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.carparkID = this.$route.query.carparkID;
        tempData.zoneID = this.$route.query.zoneID;
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);
      }

      this.hideFormFromKey('zoneID');
      if(this.$refs['pageForm'].formData.carparkID) {
        this.loadZone()
      }
    },

    loadZone() {
      this.hideFormFromKey('zoneID');
      this.$refs['pageFeedback'].setFeedbackLoading('Loading zone data...');

      let url = helper.SERVER_URL + '/api2';
      if(this.$refs['pageForm'].formData.carparkID) {
        url += '/carpark/' + this.$refs['pageForm'].formData.carparkID;
      }
      url += '/zone/';
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['zoneID'], response.data);

          if(response.data.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('No car park zone data available');
            return;
          }

          this.hideFormFromKey('name');
          if(this.$refs['pageForm'].formData.zoneID) {
              this.loadBay();
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'zone data'));
        });
    },
    loadBay() {
      this.hideFormFromKey('name');

      let feedbackItem = 'bay data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = helper.SERVER_URL + '/api2';
      url += '/bay/?1=1';
      if(this.$refs['pageForm'].formData.carparkID) {
        url += '&carparkID=' + this.$refs['pageForm'].formData.carparkID;
      }
      if(this.$refs['pageForm'].formData.zoneID) {
        url += '&zoneID=' + this.$refs['pageForm'].formData.zoneID;
      }
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, false);
          let bayTypeConst = ['Reserved', 'Tandem-Reserved', 'Non-Reserved', 'Motorcycle', 'Visitor'];
          let tempBay = {};
          for(let string of bayTypeConst) {
            tempBay[string] = {
              'type': string,
              'allocation': 0,
              'oversell': 0,
              'used': 0,
              'entitlement': 0,
              'entitlementUsed': 0,
              'remain': 0
            };
          }
          response.data.forEach(k => {
            if(k.bayType === 'NA') {
              return;
            }

            let temp = tempBay[k.bayType];

            temp['allocation']++;
            if(k.seasonID) {
              let season = this.pageProduct.find(j => j.id === k.seasonID) || {};
              if(!season.entitleOnly) {
                temp['used']++;
              } else {
                temp['entitlement']++;
              }
            }
            if(k.customerID) {
              temp['entitlementUsed']++;
            }
            temp['remain'] = temp['allocation'] + temp['oversell'] - temp['used'] - temp['entitlement'];
          });
          this.finalBay = Object.values(tempBay);
          // this.$refs['pageBay'].setTableData(this.finalBay);
          this.$refs['pageFeedback'].setFeedbackMessage();

          if(response.data.length === 0) {
            this.$refs['pageFeedback'].setFeedbackError('No car park bay data available');
            return;
          }

          this.hideFormFromKey(null);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    onCancelButtonClick() {
      let query = {};
      if(this.$route.query.carparkID) {
        query['carparkID'] = this.$route.query.carparkID;
      }
      if(this.$route.query.zoneID) {
        query['zoneID'] = this.$route.query.zoneID;
      }
      helper.redirect({ path: helper.WEB_URL + '/product', query: query });
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm()) {
        if(parseInt(this.$refs['pageForm'].formData['entitleOnly'])) {
          if(!this.$refs['pageForm'].formData['totalBays']) {
            this.$refs['pageForm'].$refs['jt-form-element-totalBays'][0].setInputError('Please set allocate bay count for entitlement product.');
            return;
          }
        }

        if(this.$refs['pageForm'].formIsAdd) {
          this.addData();
        } else {
          this.editData();
        }
      }
    },
    onDeleteButtonClick() {
      let formData = this.$refs['pageForm'].formData;
      this.deleteModalTitle = `Confirm Delete ${formData.name}?`;
      this.deleteModalBody = `Are you sure you want to delete ${formData.name}?`;
      $('#' + this.deleteModalId).modal('show');
    },
    onDeleteConfirmClick() {
      // // not applicable
      // $('#' + this.deleteModalId).modal('hide');

      // let formData = this.$refs['pageForm'].formData;
      // // let url =`${helper.SERVER_URL}/api2/season/${formData.id}`;

      // this.$refs['pageFeedback'].setFeedbackLoading('Deleting ' + formData.name);
      
      // this.$http
      //   .delete(
      //     helper.SERVER_URL + '/api2/season/' + formData.id,
      //     helper.createAxiosFormConfig()
      //   )
      //   .then(response => {
      //     this.upsertDataComplete('Successfully delete ' + formData.name);
      //   })
      //   .catch(error => {
      //     this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'deleting', 'data'));
      //   })
    },
    
    async addData() {
      let formData = this.$refs['pageForm'].formData;
      // formData['terminationTnc'] = $('#terminationTnc').summernote('code');

      formData['startDate'] = null;
      let startDate = helper.parseDateTime(formData['_startDate']);
      if(startDate) {
        formData['startDate'] = startDate.unix();
      } else {
        this.$refs['pageForm'].$refs['jt-form-element-_startDate'][0].setInputError('Please input valid date');
        return;
      }

      formData['stopDate'] = null;
      if(formData['_stopDate']) {
        let stopDate = helper.parseDateTime(formData['_stopDate']);
        if(stopDate) {
          formData['stopDate'] = stopDate.unix();
        } else {
          this.$refs['pageForm'].$refs['jt-form-element-_stopDate'][0].setInputError('Please input valid date');
          return;
        }
      } else {
        formData['stopDate'] = 0;
      }

      if(formData['totalBays']) {
        let availableBay;
				if(helper.compareID(formData['bayType'], 2)) {
          availableBay = this.finalBay.find(k => k.type === 'Reserved');
        } else if(helper.compareID(formData['bayType'], 3)) {
          availableBay = this.finalBay.find(k => k.type === 'Tandem-Reserved');
        } else if(helper.compareID(formData['bayType'], 1)) {
          availableBay = this.finalBay.find(k => k.type === 'Non-Reserved');
        } else if(helper.compareID(formData['bayType'], 4)) {
          availableBay = this.finalBay.find(k => k.type === 'Motorcycle');
        }

        if(!availableBay || availableBay.remain < parseInt(formData['totalBays'])) {
          this.$refs['pageFeedback'].setFeedbackError('Selected Zone has not enough remaining allocated bay. Please increase the allocation before creating this product.');
          return;
        }
      }

      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + formData.name);
      let result = await this.$http
        .post(
          helper.SERVER_URL + `/api2/carpark/${formData.carparkID}/zone/${formData.zoneID}/season`,
          querystring.stringify(formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'data'));
        })

      if(!result) {
        return;
      }
      
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + formData.name + ' termination terms and conditions');
      this.$http
        .post(
          helper.SERVER_URL + `/api2/season/${result[0].id}/terms`,
          querystring.stringify({
            policy: $('#terminationTnc').summernote('code')
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully added ' + formData.name + ' termination terms and conditions');
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'termination terms and conditions'));
        })
    },
    async editData() {
      let formData = this.$refs['pageForm'].formData;
      // formData['terminationTnc'] = $('#terminationTnc').summernote('code');
      formData['startDate'] = null;
      let startDate = helper.parseDateTime(formData['_startDate']);
      if(startDate) {
        formData['startDate'] = startDate.unix();
      } else {
        this.$refs['pageForm'].$refs['jt-form-element-_startDate'][0].setInputError('Please input valid date');
        return;
      }

      formData['stopDate'] = null;
      if(formData['_stopDate']) {
        let stopDate = helper.parseDateTime(formData['_stopDate']);
        if(stopDate) {
          formData['stopDate'] = stopDate.unix();
        } else {
          this.$refs['pageForm'].$refs['jt-form-element-_stopDate'][0].setInputError('Please input valid date');
          return;
        }
      } else {
        formData['stopDate'] = 0;
      }

      // let url = helper.SERVER_URL + `/api2/carpark/${formData.carparkID}/zone/${formData.zoneID}/season/` + formData.id;
      let url = helper.SERVER_URL + `/api2/season/` + formData.id;
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + formData.name);
      let result = await this.$http
        .put(
          url,
          querystring.stringify(formData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return true;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'data'));
        })

      if(!result) {
        return;
      }
      
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + formData.name + ' termination terms and conditions');
      this.$http
        .post(
          helper.SERVER_URL + `/api2/season/${formData.id}/terms`,
          querystring.stringify({
            policy: $('#terminationTnc').summernote('code')
          }),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully update ' + formData.name + ' termination terms and conditions');
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', 'termination terms and conditions'));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      helper.redirect({ path: helper.WEB_URL + '/product', query: { carparkID: this.$refs['pageForm'].formData.carparkID, zoneID: this.$refs['pageForm'].formData.zoneID }});
    },

    onFormChange(formData, parameter) {
      if(parameter.key === 'carparkID') {
        formData['zoneID'] = null;
        this.loadZone();
      } else if(parameter.key === 'zoneID') {
        this.loadBay();
      } else if(parameter.key === 'bayType') {
				if(helper.compareID(formData['bayType'], 3)) {
				  this.validateTandemBay(formData);
				} else {
					formData['baySlots'] = 1;
        }
      } else if(parameter.key === 'baySlots') {
				this.validateTandemBay(formData);
      } else if(parameter.key === 'totalBays') {
				this.validateTandemBay(formData);
      }
    },

    validateTandemBay(formData) {
      if(helper.compareID(formData['bayType'], 3)) {
        try {
          let totalBays = parseInt(formData['totalBays'] || 0);
          let baySlots = parseInt(formData['baySlots']);
          if(baySlots < 2) {
            formData['baySlots'] = baySlots = 2;
          }
          // if(totalBays % baySlots !== 0) {
          //   formData['totalBays'] = formData['baySlots'];
          // }
        } catch(e) {
          formData['baySlots'] = 2;
          // formData['totalBays'] = 0;
        }
      } else {
        formData['baySlots'] = 1;
        // if(!formData['baySlots'] || parseInt(formData['baySlots']) <= 0) {
        //   formData['baySlots'] = 1;
        // }
      }
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
    
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/CarPark/PageProductForm.vue